import { ReactNode } from "react";

import { TextBox } from "../../../components/blocks/TextBox/TextBox";

export function NotFound(): ReactNode {
  return (
    <TextBox model={window._wp.ssr.config.pageNotFound} product={undefined} />
  );
}
